export const EMPTY_PARAGRAPH: string = `<p></p>`;
export const EMPTY_CONTENT: string = "<div><p>&nbsp;</p></div>";

const centerAlignedImageRegex = /(<img).*(\bfloat(:\s*)none\b).*(\/>)/gm;

export const replaceImageStyles = (image: string, style: string): string => image.replace(/style="(.*)"/, style);

export const updateImages = (rawContent: string): string => {
  const images = rawContent.match(/(<img).*(\/>)/gm);

  if (!images) {
    return rawContent;
  }

  return images.reduce((html, img) => {
    const styles = img.match(/style="(.*)"/);

    if (!styles) {
      return html;
    }

    if (/float:(\s?)none/.test(styles[1])) {
      return html.replace(img, replaceImageStyles(img, `style="margin-bottom: 1rem; ${styles[1]}"`));
    }

    return html.replace(img, replaceImageStyles(img, `style="margin: 1rem; ${styles[1]}"`));
  }, rawContent);
};

export const updateCenterAlignedImages = (rawContent: string): string => {
  const centerAlignedImages = rawContent.match(centerAlignedImageRegex);
  if (centerAlignedImages) {
    return centerAlignedImages.reduce(
      (html, img) => html.replace(img, `<span style="text-align: center; display: block;">${img}</span>`),
      rawContent
    );
  }
  return rawContent;
};

const emptyParagraphRegex = /(<p>)\s*(<\/p>)/gm;

export const updateEmptyParagraphs = (rawContent: string): string => {
  const emptyParagraphs = rawContent.match(emptyParagraphRegex);
  if (!emptyParagraphs) {
    return rawContent;
  }
  return emptyParagraphs.reduce((html, paragraph) => html.replace(paragraph, EMPTY_PARAGRAPH), rawContent);
};

// NOTE:
// This is required due the this issue:
// https://github.com/jpuri/html-to-draftjs/issues/63
// It should be used before passing the HTML content to the htmlToDraft function
// that returns the content blocks for the editor.
export const prependParagraph = (html: string): string => {
  const images = html.match(/(<img).*(\/>)/gm);

  if (!images) {
    return html;
  }

  return `${EMPTY_PARAGRAPH}${html}`;
};
